import tmhRequest from '@/config/tmhRequest'


export default {


    createApplyStoreProduct: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applystoreproduct/createapplystoreproduct',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/apply/applystoreproduct.js